import React from "react";
import axios from "axios";

// SHARED
import Settings from "../../shared/settings";

// STYLES
import styled, { keyframes } from "styled-components";
import { fadeIn } from "react-animations";
import Colors from "../../shared/colors";

// COMPONENTS
import InputSearch from "../../components/inputsearch/inputsearch.component";
import InputResult from "../../components/inputresult/inputresult.component";
import MiniLoading from "../../components/miniloading/miniloading.component";

export default class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      oldvalue: "",
      results: [],
      status: "",
      search: false,
    };

    this.handleSearchChange.bind(this);
    this.hide = this.hide.bind(this);
  }

  handleSearchChange = (event) => {
    const { to, i18n } = this.props;

    clearTimeout(this.timer);
    this.setState({ value: event.target.value });
    if (event.target.value.length >= 2) {
      this.setState({ status: 0 });
      this.timer = setTimeout(() => {
        this.search(this.defineUrl(to, i18n));
      }, 500);
    }
    if (event.target.value.length === 0) {
      return this.resetComponent();
    }
  };

  resetComponent = () => {
    this.setState({ results: [], value: "", status: "" });
  };

  onKeyPress = (event) => {
    const { to, i18n } = this.props;

    if (event.charCode === 13) {
      this.search(this.defineUrl(to, i18n));
    }
  };

  defineUrl(to, i18n) {
    if (to === "restaurants") {
      return (
        Settings.server +
        "/api/v1/restaurant?expand=media&per-page=5&lang=" +
        i18n.language +
        "&approved=1"
      );
    } else if (to === "products") {
      return (
        Settings.server +
        "/api/v1/product?expand=media&per-page=5&lang=" +
        i18n.language
      );
    } else if (to === "recipes") {
      return (
        Settings.server +
        "/api/v1/recipe?expand=media&per-page=5&lang=" +
        i18n.language
      );
    } else {
      return (
        Settings.server +
        "/api/v1/event?expand=media&per-page=5&lang=" +
        i18n.language
      );
    }
  }

  search(url) {
    if (this.state.value.length > 1) {
      this.setState({ status: 0 });
      axios
        .get(url + "&name=" + this.state.value)
        .then((res) => {
          if (res.data.length > 0) {
            this.setState({ results: res.data, status: 1 });
          } else {
            this.setState({ results: res.data, status: 2 });
          }
        })
        .catch((err) => {
          this.setState({ status: 3 });
        });
    }
  }

  hide() {
    setTimeout(() => this.resetComponent(), 200);
  }

  render() {
    const { to, t, i18n } = this.props;

    const { value, results, status } = this.state;
    return (
      <SearchWrapper>
        <InputSearch
          placeholder={t("Pesquisar...")}
          onKeyPress={this.onKeyPress}
          onSearchChange={this.handleSearchChange}
          onSearchBlur={this.hide}
          value={value}
        />
        {status === 0 && (
          <InputResultWrapper>
            <MiniLoading />
          </InputResultWrapper>
        )}
        {status === 1 && (
          <InputResultWrapper>
            <Items>
              {results.map((result, index) => {
                return (
                  <InputResult
                    {...result}
                    key={index}
                    i18n={i18n}
                    t={t}
                    to={to}
                  />
                );
              })}
            </Items>
          </InputResultWrapper>
        )}
        {status === 2 && (
          <InputResultWrapper>
            <NotFound>{t("Sem resultados")}</NotFound>
          </InputResultWrapper>
        )}
        {status === 3 && (
          <InputResultWrapper>
            <NotFound>
              {t("Algo se passou de errado, por favor tente de novo")}!
            </NotFound>
          </InputResultWrapper>
        )}
      </SearchWrapper>
    );
  }
}

const SearchWrapper = styled.div`
  flex: 2;
`;
const fadeInAnimation = keyframes`${fadeIn}`;

const InputResultWrapper = styled.div`
  width: 430px;
  height: auto;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  z-index: 10;
  margin-top: 8px;
  box-shadow: 0 2px 4px 0 rgba(34, 36, 38, 0.12),
    0 2px 10px 0 rgba(34, 36, 38, 0.15);
  border: 1px solid #d4d4d5;
  overflow: hidden;

  @media screen and (max-width: 830px) {
    width: calc(100% - 60px);
    left: 30px;
    right: 30px;
    margin-top: 8px;
  }
`;
const Items = styled.div`
  animation: 1s ${fadeInAnimation};
`;
const NotFound = styled.div`
  padding: 20px 15px;
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  color: ${Colors.text.secondary};
  animation: 1s ${fadeInAnimation};
`;



// WEBPACK FOOTER //
// ./src/containers/Search/search.container.js